<script>
    import { mapActions, mapState } from "vuex";
    import TheSkeleton from "@main/packages/TheSkeleton";
    import BaseAccordion from "@main/packages/BaseAccordion";
    import PaymentIcons from "@/components/PaymentIcons";
    import SchemaFaq from "@/components/SchemaFaq";
    import TypographyWrapper from "@/components/TypographyWrapper.vue";

    export default {
        name: "PaymentContent",
        components: {
            TypographyWrapper,
            SchemaFaq,
            PaymentIcons,
            BaseAccordion,
            TheSkeleton,
        },
        data() {
            return {
                activeIndex: 0,
                isLoading: false,
            };
        },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage.payment,
            }),
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "payment" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.isLoading = true;
                this.getStaticPage({ slug: "payment" }).then(() => {
                    this.isLoading = false;
                });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
            changeIndex(index) {
                this.activeIndex = index;
            },
        },
    };
</script>

<template>
    <typography-wrapper>
        <div class="b-text-page">
            <the-skeleton v-if="isLoading" type="text-page"></the-skeleton>
            <template v-if="!isLoading && page">
                <div class="b-text-delivery">
                    <h2>Доставка</h2>
                    <div class="b-text-delivery__content">
                        <div class="b-text-delivery__accordion">
                            <base-accordion
                                v-for="(item, i) in page.contentLeft"
                                :key="i + 10"
                                :active-index="activeIndex"
                                :index="i"
                                :accordion="item"
                                custom-type
                                @change="changeIndex"
                            >
                            </base-accordion>
                        </div>
                    </div>
                </div>
                <div class="b-text-payment" id="payment">
                    <h2>Оплата</h2>

                    <div class="b-text-payment__content is-payment-page">
                        <div v-html="page.contentRight"></div>
                        <div class="b-text-payment__icons">
                            <payment-icons></payment-icons>
                        </div>
                    </div>
                </div>
            </template>

            <schema-faq :items="page.contentLeft"></schema-faq>
        </div>
    </typography-wrapper>
</template>

<style lang="scss">
    @import "~@/assets/sass/service-page.scss";
</style>
